module.exports = __webpack_public_path__ + "static/media/Larry the Barista.302552cf.jpg";